const getDefaultState = () => {
    return {
        attackTechniqueName: '',
        moveTechnique: {
            name: '',
            type: '',
            range: '',
            target: '',
            effect: '',
        },
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {     
        resetState: (state) => Object.assign(state, getDefaultState()),    
        setAttackTechniqueName: (state, value) => state.attackTechniqueName = value,
        setMoveTechniqueName: (state, value) => state.moveTechnique.name = value,
        setMoveTechniqueType: (state, value) => state.moveTechnique.type = value,
        setMoveTechniqueRange: (state, value) => state.moveTechnique.range = value,
        setMoveTechniqueTarget: (state, value) => state.moveTechnique.target = value,
        setMoveTechniqueEffect: (state, value) => state.moveTechnique.effect = value,
    },
}